"use client"

import { HttpTypes } from "@medusajs/types"
import { Text } from "@modules/common/components/ui"
import { useFrontendPreferences } from "@lib/frontend-preferences"

type LineItemOptionsProps = {
  variant: HttpTypes.StoreProductVariant | undefined
  label?: string
  "data-testid"?: string
  "data-value"?: HttpTypes.StoreProductVariant
}

const LineItemOptions = ({
  variant,
  label,
  "data-testid": dataTestid,
  "data-value": dataValue,
}: LineItemOptionsProps) => {
  const { t } = useFrontendPreferences()
  return (
    <Text
      data-testid={dataTestid}
      data-value={dataValue}
      className="inline-block txt-medium text-ui-fg-subtle w-full overflow-hidden text-ellipsis"
    >
      {label ?? t.cart.variant}: {variant?.title}
    </Text>
  )
}

export default LineItemOptions
